
// PhotoSwipe 5+ integration for product image zoom
if (window.PhotoSwipeLightbox && window.PhotoSwipe) {
  // Get custom SVG icons from the existing product template
  const closeSVG = '<svg focusable="false" class="icon icon--close" viewBox="0 0 14 14"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" fill="none"></path></svg>';
  
  // Simple ">" arrow for previous (flipped)
  const arrowPrevSVG = '<svg focusable="false" class="icon icon--prev" viewBox="0 0 24 24"><path d="M16 5L9 12L16 19" stroke="currentColor" fill="none"></path></svg>';
  
  // Simple ">" arrow for next
  const arrowNextSVG = '<svg focusable="false" class="icon icon--next" viewBox="0 0 24 24"><path d="M8 5L15 12L8 19" stroke="currentColor" fill="none"></path></svg>';
  
  const options = {
    gallery: '#ap_product_detail_media',
    children: 'a', 
    pswpModule: window.PhotoSwipe,
    maxZoomLevel: 1,
    zoom: false,
    counter: false,
    initialZoomLevel: 'fit',
    wheelToZoom: true,
    imageClickAction: 'close',
    tapAction: 'close',
    closeOnVerticalDrag: true,
    padding: { top: 20, bottom: 20, left: 20, right: 20 },
    
    // Custom icons
    closeSVG: closeSVG,
    arrowPrevSVG: arrowPrevSVG,
    arrowNextSVG: arrowNextSVG,
  
    // tap delay is removed if set to false
    doubleTapAction: false,
  };

  const lightbox = new window.PhotoSwipeLightbox(options);
  lightbox.init();
}
